import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import App from "./components/App";
import { lightTheme } from "./utils/theme";
import "./index.css";
import "./utils/locale/init18n";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <ThemeProvider theme={lightTheme}>
    <App />
  </ThemeProvider>
);
